<template>
  <v-container>
    <!-- Used to display the list  based on type-->
    <CompanyEmployeeList
      nextTo="CompanyApprentice"
      type="myApprentices"
      :title="$t('labels.my-apprentice')"
      :isDepartments="false"      
    />
  </v-container>
</template>

<script>
import CompanyEmployeeList from '@/components/Company/CompanyEmployeeList'
import {CompanyRoles} from '@/components/mixins'

// @group Company
// CompanyApprenticeInstructor component
export default {
  name: 'CompanyApprenticeInstructor',

  mixins: [CompanyRoles],

  components: {
    CompanyEmployeeList
  }
}
</script>

<style lang="scss">
</style>